export const Loom = (props: { id: string }) => {
    const { id } = props;

    return (
        <div style={{ position: "relative", paddingBottom: "56.25%", height: 0 }}>
            <iframe
                src={`https://www.loom.com/embed/${id}`}
                allowFullScreen={true}
                style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
            ></iframe>
        </div>
    );
};
